// extracted by mini-css-extract-plugin
export default {"cartIcon":"ShoppingCart_cartIcon__tS-Ql"};